module.exports = __webpack_public_path__ + "img/comshiva.5fe6e486.svg";